import { render, staticRenderFns } from "./wiki_sticky_header.vue?vue&type=template&id=7b650187&scoped=true&vue3"
import script from "./wiki_sticky_header.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_sticky_header.vue?vue&type=script&lang=js&vue3"
import style0 from "./wiki_sticky_header.vue?vue&type=style&index=0&id=7b650187&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b650187",
  null
  
)

export default component.exports